import Cookie from '../../utils/cookies';

const debugLogs = (logStr, val) => {
  try {
    if (
      typeof window === 'object' &&
      window.location.href.indexOf('debugLogs=1') > -1
    ) {
      console.log(logStr, val);
    }
  } catch (e) {
    //console.log(e);
  }
};

if (typeof window !== 'undefined') {
  window._toi_processedSlots = window._toi_processedSlots || [];
  window._toi_displayedSlots = window._toi_displayedSlots || [];
  window.PWT = window.PWT || {};
  window.googletag = window.googletag || {
    cmd: [],
  };
}
let iViewable = [];
let settimeoutArr = [];
let targetSlot = '';
let forcedTimeoutAdId = '';
const expectedOrder = ['atf', 'mrec', 'fbn', 'innov', 'mid1', 'mtf', 'btf'];

// let colombiadcontainerId = '';

// eslint-disable-next-line func-names
const _tvalHEP = function(v) {
  if (typeof v === 'undefined') return '';
  if (v.length > 100) return v.substr(0, 100);
  return v;
};
function iViewableIndexOf(slot) {
  const _idx = iViewable.findIndex(
    e => e.getSlotElementId() === slot.getSlotElementId(),
  );
  return _idx;
}
function isInnov(slot) {
  return slot
    .getAdUnitPath()
    .toLowerCase()
    .includes('innov');
}

const createAdObjectMapHEP = adsArray => {
  if (Array.isArray(adsArray) && adsArray.length > 0) {
    let counter = 0;
    window.Times = window.Times || {};
    window.Times.adNameMap = window.Times.adNameMap || {};
    for (; counter < adsArray.length; counter += 1) {
      if (adsArray[counter].adName) {
        window.Times.adNameMap[adsArray[counter].adCode] = adsArray[counter];
      }
    }
  }
};
// ############## Start Uncomment it for across release ###############

function dpfCanInitHEP() {
  if (window.dfpCanqueue && window.dfpCanqueue.length > 0) {
    window.dfpCanqueue.forEach(ele => {
      const { dfpslot, colombiadcontainerid, key, bidvalue } = ele;
      // TO DO size and device type should be feed driven
      const adObj = {
        adCode: dfpslot,
        size: [300, 250],
        divId: colombiadcontainerid,
        prebid: false,
        targetingInfo: { dfpCanAd: { key, bidvalue } },
        deviceType: 'mobile',
      };
      const canDfpAd = new Event('CAN_DFP');
      canDfpAd.adObject = adObj;
      window.dispatchEvent(canDfpAd);
      // colombiadcontainerId = colombiadcontainerid;
    });
    window.dfpCanqueue = [];
    // clearInterval(timer);
  }
}
function dfpCanEventListenerHEP() {
  if (typeof window !== 'undefined') {
    window.addEventListener('CAN_DFP_QUEUE', dpfCanInitHEP);
  }
}
dfpCanEventListenerHEP();

// ############## End Uncomment it for across release ###############
// if (typeof window !== 'undefined') {
//   const timer = setInterval(() => {
//     dpfCanInitHEP(timer);
//   }, 1000);
//   // setTimeout(() => {
//   //   clearInterval(timer);
//   // }, 8000);
// }

function expectedOrderFunc(genuineArr) {
  // ***************************************************************
  // End: Hack to maintain previous Impression, made this change.
  // Which will remove after deep analysis as discussed with Product
  // ***************************************************************
  const tmpArr = [];
  const tmpArr1 = [];
  expectedOrder.forEach(key => {
    genuineArr.forEach(e => {
      if (window._toi_displayedSlots.indexOf(e.getSlotElementId()) > -1) {
        return true;
      }
      if (e) {
        if (e.getAdUnitPath().match(new RegExp(key, 'gi'))) {
          tmpArr.push(e);
        } else {
          tmpArr1.push(e);
        }
        window._toi_displayedSlots.push(e.getSlotElementId());
      }
      return true;
    });
  });
  const arr = [...new Set(tmpArr.concat(tmpArr1))];
  return arr;
}

function initAdserverHEP(forced, adsArray, targetDiv) {
  debugLogs('***** initAdserverHEP 0', adsArray);
  debugLogs('event.targetDiv', targetDiv);
  if (targetDiv) {
    debugLogs('event.targetDiv inside', targetDiv);
    targetSlot = targetDiv;
    window.googletag.pubads().refresh([targetSlot]);
  } else if (
    (forced && !window.initAdserverHEPFlag) ||
    (window.a9_BidsInit &&
      window.PWT.a9_BidsReceived &&
      window.PWT.ow_BidsReceived) ||
    ((!window.PWT.prebidOn || !window.a9_BidsInit) &&
      window.PWT.ow_BidsReceived)
  ) {
    window.initAdserverHEPFlag = true;
    window.a9_BidsInit = false;
    window.PWT.a9_BidsReceived = false;
    window.PWT.ow_BidsReceived = false;
    window.PWT.adSlotsArr = [];
    if (Array.isArray(adsArray) && adsArray.length > 0) {
      debugLogs(
        `########## DISPLAY REQUEST before filter ******* : ${adsArray.length}`,
      );
      const orderedSlotObj = expectedOrderFunc(adsArray);
      debugLogs(
        `########## DISPLAY REQUEST SENT Total(${
          orderedSlotObj.length
        }) **************** : ${performance.now()}`,
        JSON.stringify(
          orderedSlotObj.map(e => {
            const rObj = {};
            rObj.code = e.getAdUnitPath();
            rObj.id = e.getSlotElementId();
            return rObj;
          }),
        ),
      );
      if (orderedSlotObj.length > 0)
        window.googletag.pubads().refresh(orderedSlotObj);
    }
  }
  return true;
}
function getCcaudDataHEP() {
  let _auds = '';
  if (typeof colaud !== 'undefined') {
    _auds = window.colaud.aud;
  } else if (
    typeof localStorage !== 'undefined' &&
    typeof localStorage.getItem('colaud') !== 'undefined' &&
    localStorage.getItem('colaud') !== null
  ) {
    _auds = localStorage.getItem('colaud');
  }
  return _auds;
}

function pushAdSlotsToInitArrHEP(adSlots) {
  window.PWT.adSlotsArr = window.PWT.adSlotsArr || [];
  window.PWT.adSlotsArr = window.PWT.adSlotsArr.concat(adSlots);
}

export function doPubmaticBiddingHEP(adSlotsArr, timeoutAdId) {
  // OpenWrap code START here
  if (typeof window.PWT.requestBids === 'function') {
    debugLogs(
      '***** doPubmaticBiddingHEP ',
      JSON.stringify(adSlotsArr.map(e => e.getAdUnitPath())),
    );
    window.PWT.requestBids(
      window.PWT.generateConfForGPT(adSlotsArr),
      adUnitsArray => {
        window.PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
        window.PWT.ow_BidsReceived = true;
        debugLogs(
          '****** doPubmaticBiddingHEP inner',
          adUnitsArray,
          adSlotsArr,
          'window.PWT.ow_BidsReceived',
          window.PWT.ow_BidsReceived,
        );
        if (forcedTimeoutAdId !== timeoutAdId) {
          pushAdSlotsToInitArrHEP(adSlotsArr);
          debugLogs(
            `########## doPubmaticBiddingHEP received: ${
              window.PWT.adSlotsArr.length
            }`,
            JSON.stringify(window.PWT.adSlotsArr.map(e => e.getAdUnitPath())),
          );
          initAdserverHEP(false, window.PWT.adSlotsArr);
          forcedTimeoutAdId = 1;
        }
      },
    );
  }
}

// whenever you want header bids call this function
function fetchHeaderBidsHEP(apstagSlots, timeoutAdId) {
  // console.info('bidder func called');
  debugLogs('#### fetchHeaderBidsHEP apstagSlots', apstagSlots);
  // get only gpt div id's that match slotIDs passed in fetchBids request
  function _getGPTSlots(apstags) {
    // get all of the slot IDs that were requested
    const slotIDs = apstags.map(slot => slot.slotID);
    // return the slot objects corresponding to the gpt slotIDs
    return window.googletag
      .pubads()
      .getSlots()
      .filter(
        slot =>
          // return true if the ID of the slot object is in the gpt slotIDs array
          slotIDs.indexOf(slot.getSlotElementId()) > -1,
      );
  }

  function doAmazonHeaderBiddingHEP(apstagSlotsArr) {
    const gptSlotsToRefresh = _getGPTSlots(apstagSlotsArr);
    if (gptSlotsToRefresh && gptSlotsToRefresh.length > 0) {
      window.a9_BidsInit = true;
      window.googletag.cmd.push(() => {
        window.apstag.fetchBids(
          {
            slots: gptSlotsToRefresh,
          },
          // eslint-disable-next-line no-unused-vars
          bids => {
            window.apstag.setDisplayBids();
            window.PWT.a9_BidsReceived = true;
            if (forcedTimeoutAdId !== timeoutAdId) {
              pushAdSlotsToInitArrHEP(gptSlotsToRefresh);
              debugLogs(
                `########## doAmazonHeaderBiddingHEP received: ${
                  window.PWT.adSlotsArr.length
                }`,
                JSON.stringify(
                  window.PWT.adSlotsArr.map(e => e.getAdUnitPath()),
                ),
              );
              initAdserverHEP(false, window.PWT.adSlotsArr);
              forcedTimeoutAdId = 1;
            }
          },
        );
      });
    }
  }

  // set timeout to send request to call sendAdserverRequest() after timeout
  // if all bidders haven't returned before then
  doAmazonHeaderBiddingHEP(apstagSlots);
}

function HPgutterRefershLogic(e) {
  // HP Gutter ad should refresh One time after 30s
  // If 1st request servered empty then no refresh
  setTimeout(() => {
    const __idx = iViewableIndexOf(e);
    if (__idx !== -1) return true;
    window.googletag.pubads().refresh([e]);
    iViewable.push(e);
    debugLogs(
      '#### impressionViewable REQUEST SENT after 30s ',
      e.getAdUnitPath(),
    );
    return true;
  }, 30000);
}

function emitSlotLoadEvent(slot) {
  const adCode = slot.getAdUnitPath();
  const divId = slot.getSlotElementId();
  if (
    adCode.toLowerCase().includes('_atf') &&
    divId.toLowerCase().includes('-atf')
  ) {
    const slotRenderedEvent = new CustomEvent('PROCESS_ATF_STICKY', {
      detail: {
        adCode,
        divId,
      },
    });
    window.dispatchEvent(slotRenderedEvent);
  }
}

function viewableImpression() {
  // Continous refresh after viewable impression
  window.googletag.cmd.push(() => {
    window.googletag.pubads().addEventListener('impressionViewable', event => {
      // eslint-disable-next-line prefer-destructuring
      const slot = event.slot;
      const idx = iViewableIndexOf(slot);
      if (slot.getAdUnitPath().match(new RegExp('_1x1', 'gi')) || idx !== -1) {
        return true;
      }
      if (
        document
          .getElementById(slot.getSlotElementId())
          .querySelector('.andbeyond_adunit') === null &&
        slot.getAdUnitPath().includes('TOI') &&
        !isInnov(slot) &&
        !slot.getAdUnitPath().includes('TOI_Cube') &&
        !slot.getAdUnitPath().includes('TOI_MWeb_Cube')
      ) {
        const iViewableExecute = e => {
          const settimeout = setTimeout(() => {
            const __idx = iViewableIndexOf(e);
            if (document.hidden || isInnov(e) || __idx === -1) return true;
            if (typeof window.PWT.requestBids === 'function') {
              doPubmaticBiddingHEP([e]);
              fetchHeaderBidsHEP([{ slotID: e.getSlotElementId() }]);
              window._toi_displayedSlots = window._toi_displayedSlots.filter(
                li => li !== e.getSlotElementId(),
              );
            } else {
              window.googletag.pubads().refresh([e]);
            }
            iViewable.splice(__idx, 1);
            debugLogs(
              `#### impressionViewable REQUEST Next after 30s ${performance.now()}`,
              e.getAdUnitPath(),
            );
            return true;
          }, 30000);
          settimeoutArr.push(settimeout);
          return true;
        };
        //debugLogs(`#### **** ${slot.getAdUnitPath()}`, JSON.stringify(iViewable.map(e => e.getAdUnitPath())));
        iViewable.push(slot);
        iViewableExecute(slot);
      }
      return true;
    });
  });
}
function visibilitychange() {
  // Continous refresh after viewable impression
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      settimeoutArr.forEach(_e => {
        clearTimeout(_e);
      });
      settimeoutArr = [];
      return true;
    }
    if (typeof window.PWT.requestBids === 'function') {
      iViewable.map(e => {
        doPubmaticBiddingHEP([e]);
        fetchHeaderBidsHEP([{ slotID: e.getSlotElementId() }]);
        window._toi_displayedSlots = window._toi_displayedSlots.filter(
          li => li !== e.getSlotElementId(),
        );
        return true;
      });
    } else {
      window.googletag.cmd.push(() => {
        window.googletag.pubads().refresh(iViewable);
      });
    }
    debugLogs(
      '#### visibilitychange REQUEST Next : ',
      JSON.stringify(
        iViewable.map(e => {
          const rObj = {};
          rObj.code = e.getAdUnitPath();
          rObj.id = e.getSlotElementId();
          return rObj;
        }),
      ),
    );
    iViewable.forEach((_e, i) => {
      if (!isInnov(_e)) {
        // set this slot as null in iViewable
        // not removing from array as it breaks the loop sequence
        // Reason: don't want to remove Innov for continous
        // Visibility chagnge refresh
        iViewable[i] = null;
      }
    });

    // removing null values from iViewable
    iViewable = iViewable.filter(_item => _item !== null);
    return true;
  });
}

function addSlotRequestedEventHEP() {
  if (window.slotRequestEvent === '1') {
    return;
  }
  try {
    window.slotRequestEvent = '1';
    window.googletag.pubads().addEventListener('slotRenderEnded', event => {
      debugLogs('event.slot', event.slot.getSlotElementId());
      // targetSlot && debugLogs('event.target', targetSlot.getSlotElementId());
      if (
        event !== undefined &&
        !event.isEmpty &&
        isInnov(event.slot) &&
        iViewableIndexOf(event.slot) === -1
      ) {
        HPgutterRefershLogic(event.slot);
      }
      if (event.slot === targetSlot) {
        if (event.isEmpty && window.colombia) {
          window.googletag.destroySlots([targetSlot]);
          // debugLogs('colombiadcontainerid10', colombiadcontainerId);
          debugLogs('colombiadcontainerid11', targetSlot.getSlotElementId());
          window.colombia.setdfpstatus('fail', targetSlot.getSlotElementId());
        } else {
          // debugLogs('colombiadcontainerid20', colombiadcontainerId);
          debugLogs('colombiadcontainerid21', targetSlot.getSlotElementId());
          window.colombia.setdfpstatus(
            'success',
            targetSlot.getSlotElementId(),
          );
        }
        targetSlot = '';
      } else {
        const adSlot = event.slot.getAdUnitPath();
        let foundAdObject;
        if (
          window.Times &&
          window.Times.adNameMap &&
          window.Times.adNameMap[adSlot]
        ) {
          foundAdObject = window.Times.adNameMap[adSlot];
          // for (let i = 0; i < adsArray.length; i += 1) {
          //   if (adsArray[i].adCode === adSlot) {
          //     foundAdObject = adsArray[i];
          //     break;
          //   }
          // }
        }
        if (foundAdObject && foundAdObject.adName && !event.isEmpty) {
          document.body.classList.add(foundAdObject.adName);
          //TODO: this solution is a quick fix to solve live iussue. Proper solution need to be implemented
          if (foundAdObject.adName === 'fallback') {
            document.body.classList.add('gutter');
          }
        }
        if (foundAdObject && foundAdObject.adName === 'gutter') {
          if (event.isEmpty && foundAdObject.fallback) {
            const setGutterFallbackEvent = new Event('SET_GUTTER_FALLBACK');
            setGutterFallbackEvent.showGutterFallback = true;
            setGutterFallbackEvent.gutterFallbackAdObject =
              foundAdObject.fallback;
            setGutterFallbackEvent.gutterFallbackAdObject.gutterFallback = true;
            window.gutterFallbackAdObject = foundAdObject.fallback;
            // destroy gutter in case fallback
            window.googletag.destroySlots([event.slot]);
            window.dispatchEvent(setGutterFallbackEvent);
            if (window.template === 'liveblog') {
              if (typeof Event === 'function') {
                // modern browsers
                window.dispatchEvent(new Event('resize'));
              } else {
                const el = window;
                const event1 = document.createEvent('HTMLEvents');
                event1.initEvent('resize', true, false);
                el.dispatchEvent(event1);
              }
            }
          }
        }
        window.dispatchEvent(new Event('GUTTER_ACTIVE_AD_TYPE'));
        const fallbackAds = window.gutterFallbackAdObject;
        if (
          fallbackAds &&
          ((fallbackAds.adCode && fallbackAds.adCode === adSlot) ||
            (fallbackAds.lhs && fallbackAds.lhs.adCode === adSlot) ||
            (fallbackAds.rhs && fallbackAds.rhs.adCode === adSlot))
        ) {
          if (!document.body.classList.contains('bgImg') && !event.isEmpty) {
            document.body.classList.add('bgImg');
          }
        }
      }
    });

    window.googletag.pubads().addEventListener('slotOnload', event => {
      if (!event.isEmpty) {
        emitSlotLoadEvent(event.slot);
      }
    });

    window.adsCallback = adtype => {
      if (typeof adtype !== 'undefined') {
        switch (adtype) {
          case 'gutter': {
            const gutterAdTypeHandling = new Event('GUTTER_AD_TYPE_HANDLING');
            window.dispatchEvent(gutterAdTypeHandling);
            break;
          }
          case 'gutterclose': {
            const gutterCloseAdTypeHandling = new Event(
              'GUTTER_CLOSE_AD_TYPE_HANDLING',
            );
            window.dispatchEvent(gutterCloseAdTypeHandling);
            break;
          }
          case 'expandoclose': {
            const expandCloseAdTypeHandling = new Event(
              'EXPAND_CLOSE_AD_TYPE_HANDLING',
            );
            window.dispatchEvent(expandCloseAdTypeHandling);
            break;
          }
          default:
            break;
        }
      }
    };
    if (
      typeof window.geoinfo === 'object' &&
      window.geoinfo.CountryCode === 'IN'
    ) {
      viewableImpression();
      visibilitychange();
    }
  } catch (e) {
    // console.log(e);
  }
}

function checkForGeoInfoInAdHEP(defaultObj, geo, objName) {
  if (
    typeof geo === 'object' &&
    typeof window.geoinfo === 'object' &&
    typeof geo[objName] === 'object' &&
    geo[objName][window.geoinfo.CountryCode] instanceof Array
  ) {
    return geo[objName][window.geoinfo.CountryCode];
  }
  return defaultObj;
}

export const displayAllAdsInArrayHEP = (
  adsArray,
  refreshableAdsList,
  path,
  isMobile,
) => {
  const isWapView = isMobile;
  if (typeof window !== 'object') {
    return;
  }
  debugLogs('#### My Code is Ready:', performance.now());
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];
  const { googletag } = window;
  let globalHyp1 = '';
  let BL = 0;
  let _ARC1 = '';
  let dfpCanAd = '';
  const PPIDCookieVal = Cookie.get('_col_uuid');
  const PPIDFlag = PPIDCookieVal ? 'true' : 'false';
  const apstagSlots = [];
  const definedSlots = [];
  let targetDiv = '';

  let enableMraLazyLoadAds = false;
  if (
    (window.location.pathname === '/us-testads' &&
      window.location.search.indexOf('test=true') > -1) ||
    (window.location.pathname === '/us' &&
      window.location.search.indexOf('mratest=true') > -1)
  ) {
    enableMraLazyLoadAds = true;
  }
  window.googletag.cmd.push(() => {
    if (window.TimesGDPR) {
      window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
        if (dataObj.isEUuser && dataObj.didUserOptOut === false) {
          //user has has given consent for personalised ads ( i.e did not opt out )
          window.googletag.pubads().setRequestNonPersonalizedAds(0);
        } else if (dataObj.isEUuser) {
          window.googletag.pubads().setRequestNonPersonalizedAds(1);
        }
        createAdObjectMapHEP(adsArray);
        addSlotRequestedEventHEP(adsArray);
      });
    }
    debugLogs('#### googletag Ready: ', performance.now());
    const _auds = getCcaudDataHEP() || [];
    const pubads = googletag.pubads();
    const altPath = path && path.length > 0 ? path.split('/') : [];
    let pathList = window.location.pathname.split('/');
    if (pathList.length === 0 || !pathList[1]) {
      pathList = ['default', 'home'];
    }
    const sectionName = altPath[1] || pathList[1];
    // targeting started
    pubads.setTargeting('sg', _auds);
    if (!window?.Times?.adsKeys?.Channel) {
      if (sectionName === 'entertainment' || sectionName === 'etimes') {
        pubads.setTargeting('channel', 'etimes');
      } else {
        pubads.setTargeting('channel', 'toi');
      }
    }

    if (isWapView) {
      if (window.location.href.indexOf('.cms') >= 0) {
        const pathListforRpmId = [...pathList];
        const asIndex = pathListforRpmId.indexOf('articleshow');
        if (asIndex !== -1) {
          pathListforRpmId[asIndex] = 'articlestory';
        }
        pubads.setTargeting(
          '_rpmid',
          `${_tvalHEP(
            `${pathListforRpmId[pathListforRpmId.length - 2]}_${sectionName}`,
          )}`,
        );
      } else {
        pubads.setTargeting('_rpmid', `${_tvalHEP(pathList.join('_'))}`);
      }
      pubads.setTargeting('_category', _tvalHEP(pathList[1]));
      //TOIPR-65945 - Pass "frmapp" key-value in Mweb Ad Requests
      if (window.location.search.includes('frmapp=yes')) {
        pubads.setTargeting('frmapp', 'yes');
      }
    }
    pubads.setTargeting('aud_flag', PPIDFlag);
    if (PPIDFlag) {
      pubads.setTargeting('col_key', PPIDCookieVal);
    }
    if (sectionName !== 'home' && !window?.Times?.adsKeys?.SCN) {
      pubads.setTargeting('SCN', _tvalHEP(sectionName));
    }
    if (
      !window.Times.adsKeys ||
      (window.Times.adsKeys && !window.Times.adsKeys.Tmpl_SCN)
    ) {
      pubads.setTargeting(
        'Tmpl_SCN',
        `${pathList[pathList.length - 2]}_${sectionName}`,
      );
    }
    // Lastsubscn should be picked from subsecs only if subsecs,
    // if not subsecs then URL which is
    // already called from template as setSubSecNavFrmUrl in ads/utils.js
    if (typeof window !== 'undefined' && window.Times && window.Times.adsKeys) {
      const adsKeys = Object.keys(window.Times.adsKeys);
      adsKeys.forEach(key => {
        const val = window.Times.adsKeys[key];
        if (typeof val !== 'undefined') {
          pubads.setTargeting(key, window.Times.adsKeys[key]);
        }
      });
    }
    pubads.setTargeting('fic', '0');
    pubads.setTargeting('SCP', '0');

    if (targetDiv) {
      targetDiv.setTargeting(dfpCanAd.key, dfpCanAd.bidvalue);
      dfpCanAd = '';
    }
    // targeting ended

    // defining adslots below
    adsArray.forEach(adObject => {
      const {
        adCode,
        divId,
        hyp1,
        cookieKey,
        targetingInfo,
        callback,
        prebid,
        geo,
        // dfpParams = {},
      } = adObject;
      if (window._toi_processedSlots.indexOf(divId) !== -1 || !adCode)
        return false;
      let { mlb } = adObject;
      let { size } = adObject;
      globalHyp1 = hyp1 || globalHyp1;

      mlb = checkForGeoInfoInAdHEP(mlb, geo, 'mlb');
      size = checkForGeoInfoInAdHEP(size, geo, 'size');
      if (targetingInfo && typeof targetingInfo.dfpCanAd === 'object') {
        dfpCanAd = targetingInfo.dfpCanAd;
      }
      if (
        typeof cookieKey === 'string' &&
        cookieKey.length > 0 &&
        Cookie.get(cookieKey)
      ) {
        return true;
      }
      if (
        targetingInfo &&
        typeof targetingInfo._HYP1 === 'string' &&
        globalHyp1 !== targetingInfo._HYP1
      ) {
        globalHyp1 = targetingInfo._HYP1;
      }
      if (
        targetingInfo &&
        typeof targetingInfo.BL === 'number' &&
        BL !== targetingInfo.BL
      ) {
        BL = targetingInfo.BL;
      }
      if (
        targetingInfo &&
        typeof targetingInfo._ARC1 === 'string' &&
        _ARC1 !== targetingInfo._ARC1
      ) {
        _ARC1 = targetingInfo._ARC1;
      }
      if (typeof globalHyp1 === 'string' && globalHyp1 !== '') {
        pubads.setTargeting('hyp1', _tvalHEP(globalHyp1));
      }
      if (BL === 1) {
        //Porn Targeting
        pubads.setTargeting('BL', _tvalHEP(`${BL}`));
      }
      if (_ARC1) {
        //Porn Targeting
        pubads.setTargeting('ARC1', _tvalHEP(_ARC1));
      }
      if (
        (isWapView && adObject.deviceType === 'mobile') ||
        (!isWapView && adObject.deviceType !== 'mobile') ||
        adObject.deviceType === 'all'
      ) {
        window.googletag.cmd.push(() => {
          if (!size) {
            if (googletag) {
              const googleTagOutOfPageSlot = googletag.defineOutOfPageSlot(
                adCode,
                divId,
              );
              if (googleTagOutOfPageSlot) {
                googleTagOutOfPageSlot.addService(googletag.pubads());
                definedSlots.push(googleTagOutOfPageSlot);
              }
              if (adObject.adType === 'gutter' && googleTagOutOfPageSlot) {
                window.gutterFallbackObj = googleTagOutOfPageSlot;
              }
            }
          } else {
            const adCodeObj = googletag.defineSlot(adCode, size, divId);
            if (adCodeObj) {
              definedSlots.push(adCodeObj);
            }
            if (PPIDCookieVal) {
              googletag.pubads().setPublisherProvidedId(PPIDCookieVal);
            }
            if (enableMraLazyLoadAds) {
              googletag.pubads().enableLazyLoad({
                // Fetch slots within 5 viewports.
                fetchMarginPercent: 100,
                // Render slots within 2 viewports.
                renderMarginPercent: 100,
                // Double the above values on mobile, where viewports are smaller
                // and users tend to scroll faster.
                mobileScaling: 2.0,
              });
            }
            // const adSlotDefined = new CustomEvent('adSlotDefined', {
            //   detail: {
            //     adCode,
            //     adCodeObj,
            //     divId,
            //   },
            // });
            // window.dispatchEvent(adSlotDefined);
            if (adObject.gutterFallback) {
              window.gutterFallbackObj = adCodeObj;
            }
            // if (adCodeObj && dfpParams.doNotCollapse) {
            //   adCodeObj.setCollapseEmptyDiv(false);
            // }
            if (isWapView && adCodeObj && adCodeObj.setCollapseEmptyDiv) {
              adCodeObj.setCollapseEmptyDiv(false);
            }
            if (
              isWapView &&
              adCodeObj &&
              !(adCodeObj.mlb instanceof Array) &&
              size[0] instanceof Array &&
              size.length > 2 &&
              mlb !== 'no'
            ) {
              const mappingATF = googletag
                .sizeMapping()
                .addSize([1, 1], [320, 50])
                .addSize([480, 200], [468, 60])
                .addSize([768, 200], [728, 90])
                .build();
              adCodeObj.defineSizeMapping(mappingATF);
            }

            //Adding Size Mapping for Responsive Ads
            if (mlb && mlb.length > 0) {
              let mlbCodeObj;
              mlbCodeObj = googletag.sizeMapping();
              for (let j = 0; j < mlb.length; j += 1) {
                mlbCodeObj = mlbCodeObj.addSize(mlb[j][0], mlb[j][1]);
              }
              if (adCodeObj) {
                adCodeObj.defineSizeMapping(mlbCodeObj.build());
              }
            }
            if (adCodeObj) {
              adCodeObj.addService(googletag.pubads());
              if (dfpCanAd) {
                targetDiv = adCodeObj;
                // dfpCanAd = '';
              }
            }
            if (typeof callback === 'function') {
              callback(adCodeObj, divId, adObject);
            }
            if (adObject.refreshAd) {
              refreshableAdsList.push(adCodeObj);
            }
            window._toi_processedSlots.push(divId);
          }
          if (prebid) {
            apstagSlots.push({ slotID: divId, sizes: size, slotName: adCode });
          }
          debugLogs(`######## DefineSlot done ${divId}`, adCode);
        });
      }
      return true;
    });

    // googletag settings started
    if (!enableMraLazyLoadAds) {
      googletag.pubads().enableSingleRequest();
    }
    googletag.pubads().enableAsyncRendering();
    googletag.pubads().collapseEmptyDivs(true);
    googletag.enableServices();
    googletag.pubads().disableInitialLoad();

    if (definedSlots.length === 0) return false;
    window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
      if (dataObj.isEUuser) {
        debugLogs(
          `########## EU User Cases - before ad request calls`,
          JSON.stringify(definedSlots.map(e => e.getAdUnitPath())),
        );
        window.PWT.ow_BidsReceived = true;
        window.PWT.a9_BidsReceived = true;
        initAdserverHEP(false, definedSlots);
      } else {
        debugLogs('#### apstagSlots', apstagSlots);
        doPubmaticBiddingHEP(definedSlots, window.btoa(definedSlots));
        fetchHeaderBidsHEP(apstagSlots, window.btoa(definedSlots));
        // googletag setting ended
        debugLogs('**** doPubmaticBiddingHEP before call', definedSlots);
      }
    });

    let FAILSAFE_TIMEOUT = 1200;
    if (
      typeof window.geoinfo === 'object' &&
      window.geoinfo.CountryCode !== 'IN'
    ) {
      FAILSAFE_TIMEOUT = 2000;
    }
    if (targetDiv !== '') {
      debugLogs(
        `########## targetDiv executed `,
        JSON.stringify(targetDiv.map(e => e.getAdUnitPath())),
      );
      initAdserverHEP(true, '', targetDiv);
    }

    if (forcedTimeoutAdId === '') {
      setTimeout(() => {
        if (forcedTimeoutAdId === '') {
          debugLogs(
            `########## TimeOut executed (${FAILSAFE_TIMEOUT}ms)`,
            JSON.stringify(definedSlots.map(e => e.getAdUnitPath())),
          );
          initAdserverHEP(true, definedSlots);
          forcedTimeoutAdId = window.btoa(definedSlots);
        }
      }, FAILSAFE_TIMEOUT);
    }
    return true;
  });
};

if (typeof window !== 'undefined') {
  window.forceOffTransform = () => {
    try {
      window.toi_force_off_transform = true;
      const stopObserveCLSResizeEvent = new Event('toi_force_off_transform');
      window.dispatchEvent(stopObserveCLSResizeEvent);
      //wrapperclearfix class is present on main dic of page.
      // add this class to div, we are transforming page for CLS handling
      const contentWrapperMobileEle = document.querySelector(
        '.wrapperclearfix',
      );
      if (contentWrapperMobileEle) {
        const translatedValue =
          contentWrapperMobileEle.style.marginBottom.replace('px', '') - 0;
        if (translatedValue > 0) {
          contentWrapperMobileEle.style.transform = 'none';
          contentWrapperMobileEle.style.marginBottom = 'unset';
        }
      }
      const atfWrapperMobileEle = document.querySelector('.ATF_wrapper');
      if (atfWrapperMobileEle) {
        debugLogs('atfWrapperMobileEle', atfWrapperMobileEle);
        //setting same min height and making height to auto
        atfWrapperMobileEle.style.minHeight = atfWrapperMobileEle.style.height;
        atfWrapperMobileEle.style.height = 'auto';
      }
    } catch (e) {
      debugLogs(e);
    }
  };
}
